import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPlus } from '../../../utils/count';
import CountBox from '../../../components/CountBox';
import { WalletAssetItem } from '../../../types/api';

type Props = {
  walletAssetList: WalletAssetItem[];
}

const TotalView: React.FC<Props> = ({ walletAssetList }) => {
  const [total, setTotal] = useState<number>(0);
  const [wait] = useState<number>(0);
  const { t } = useTranslation();

  useEffect(() => {
    const count = walletAssetList.reduce((prev, curr) => getPlus(prev, Number(curr.usd)), 0);
    setTotal(count);
  }, [walletAssetList]);

  return (
    <CountBox
      title={t('total_balance')}
      count={`$ ${total.toLocaleString()}`}
      tip={`${t('uncertified')} $ ${wait.toLocaleString()}`}
      icon="iconzichan"
    />
  );
};

export default TotalView;
